import React from 'react';
import { Button } from "../../design_system/components/Button/Button";
import AnNewDropdown from '../cta_utils/AnNewDropdown'

export const AnConfirmDropdown = ({
    message = "Are you sure you want to perform this action?",
    onSubmitCallback,
    onCancelCallback,
    isLoading = false,
    btnLabels = { submitLabel: 'Save', cancelLabel: 'Cancel' },
    ...props
}) => {
    const { submitLabel, cancelLabel } = btnLabels;

    return (
        <AnNewDropdown
            style={{
                position: 'absolute',
                right: 0,
                padding: 'var(--space-l)',
                background: 'var(--color-surface-elevated)',
                boxShadow: 'var(--shadow-l2)',
                borderRadius: 'var(--radius-m)',
                width: '240px',
                zIndex: 999,
                ...props.dropdownStyle
            }}
            toggleDropDown={onCancelCallback}
        >
            <div className="body-s-semibold confirm-dropdown__message">
                {message}
            </div>

            <div className="confirm-dropdown__actions">
                <Button 
                    Type="Secondary" 
                    Size="Small"
                    onClick={(e) => {
                        if (e) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onCancelCallback();
                    }}
                >
                    {cancelLabel}
                </Button>
                <Button 
                    Type="Primary" 
                    Size="Small"
                    isLoading={isLoading}
                    onClick={onSubmitCallback}
                >
                    {submitLabel}
                </Button>
            </div>
        </AnNewDropdown>
    );
};